const HERO_IMG =
  'https://readdy.ai/api/search-image?query=Editorial%20investigative%20report%20flat%20lay%20on%20warm%20cream%20parchment%20paper%2C%20newspaper%20clippings%2C%20timeline%20dotted%20lines%20and%20handwritten%20red%20marker%20annotations%2C%20stacked%20evidence%20documents%20with%20a%20brass%20magnifying%20glass%20resting%20over%20text%20sheets%2C%20cinematic%20warm%20side%20lighting%20with%20deep%20ink%20shadows%2C%20no%20people%2C%20no%20faces%2C%20abstract%20documentary%20composition%2C%20dark%20espresso%20ink%20and%20warm%20vermilion%20accent%20tones%20on%20a%20light%20beige%20background%2C%20rich%20detail%20and%20depth%2C%20photorealistic&width=1920&height=860&seq=hero-blackmaterial-x1&orientation=landscape';

const READ_CHIPS = [
  { icon: 'ri-image-2-line', label: '图文详解 36 图' },
  { icon: 'ri-focus-3-line', label: '时间线图解' },
  { icon: 'ri-book-open-line', label: '长文万字拆解' }
];

export default function Hero() {
  return (
    <section className="border-b border-line">
      {/* 主视觉压顶 */}
      <div className="relative h-[440px] overflow-hidden md:h-[600px]">
        <img
          src={HERO_IMG}
          alt="最全黑料头版专题视觉"
          title="最全黑料 - 头版深度专题"
          className="h-full w-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-[#1c140c]/95 via-[#1c140c]/30 to-transparent" />

        {/* 左上角标 */}
        <div className="absolute left-4 top-5 md:left-6 md:top-6">
          <div className="flex items-center gap-2 bg-verm px-3 py-1.5 text-xs font-bold tracking-widest text-paper2">
            今日头版 · TOP 1
          </div>
        </div>

        {/* 文案区 */}
        <div className="absolute inset-x-0 bottom-0">
          <div className="mx-auto max-w-[1360px] px-4 pb-8 md:px-6 md:pb-10">
            <div className="flex items-center gap-2 text-xs text-gold-soft">
              <i className="ri-pushpin-2-fill" />
              <span className="tracking-widest">长文连载 · 第 14 期</span>
            </div>
            <h1 className="font-display mt-3 max-w-3xl text-2xl font-black leading-snug text-paper2 md:text-5xl md:leading-tight">
              一场迟到了半年的连麦对质：从一句"无意冒犯"到两版声明，全程图文时间线复盘
            </h1>
            <p className="mt-3 max-w-2xl text-sm leading-relaxed text-paper2/85 md:text-base">
              主播对线、站队又删帖，前因后果散落十几个平台。本期把双方发言、原帖、转发时间全部打标排序，配细节图解，一次性看完整段经过。
            </p>

            <div className="mt-5 flex flex-wrap items-center gap-3">
              <a
                href="#long-read"
                className="whitespace-nowrap bg-verm px-5 py-2.5 text-sm font-semibold text-paper2 hover:bg-verm-dark"
              >
                阅读本期长文
                <i className="ri-arrow-right-line ml-1.5" />
              </a>
              <a
                href="#diagram"
                className="whitespace-nowrap border border-paper2/50 px-5 py-2.5 text-sm font-semibold text-paper2 hover:border-verm hover:text-verm"
              >
                先看图解版
              </a>
              <div className="ml-1 hidden flex-wrap gap-2 md:flex">
                {READ_CHIPS.map((c) => (
                  <span
                    key={c.label}
                    className="flex items-center gap-1.5 rounded-full bg-black/35 px-3 py-1.5 text-xs text-paper2/90 backdrop-blur"
                  >
                    <i className={`${c.icon} text-gold-soft`} />
                    {c.label}
                  </span>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* 头版四连小卡：标题优先、配图克制 */}
      <div className="mx-auto max-w-[1360px] px-4 md:px-6">
        <div className="grid grid-cols-2 divide-x divide-y divide-line/80 border-x border-b border-line bg-paper2 md:grid-cols-4 md:divide-y-0">
          {[
            { tag: '深扒', title: '一条被删的晒单，暴露了代运营的自评套路', meta: '图文详解 · 5.2k 阅读' },
            { tag: '图解', title: '回应声明逐句拆：哪里是回应，哪里是回避', meta: '图解 8 图 · 讨论 214' },
            { tag: '长文', title: '从合伙到分家，内部群聊时间线还原始末', meta: '万字拆解 · 已更 6 期' },
            { tag: '合集', title: '同款"被离职"话术合集，已有 11 个样本', meta: '合集 · 持续收录中' }
          ].map((c, i) => (
            <a href="#deep-read" key={i} className="group flex flex-col gap-2 p-4 transition-colors hover:bg-verm-soft md:p-5">
              <div className="flex items-center gap-2 text-[11px] font-semibold tracking-widest text-verm">
                <span className="bg-verm-soft px-1.5 py-0.5">0{i + 1}</span>
                {c.tag}
              </div>
              <h3 className="font-display text-sm font-bold leading-snug group-hover:text-verm md:text-base">
                {c.title}
              </h3>
              <span className="flex items-center gap-1 text-xs text-ink/45">
                <i className="ri-arrow-right-up-line" />
                {c.meta}
              </span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}